/**
 * Default storefront pages shared by all tenants until overridden in
 * storefronts/{tenantKey}/pages/.
 */
import HomePage from "pages/home/HomePage";
import ProductCatalog from "pages/catalog/ProductCatalog";
import ProductDetail from "pages/catalog/ProductDetail";
import Cart from "pages/cart/Cart";
import Checkout from "pages/checkout/Checkout";
import SignIn from "layouts/authentication/sign-in";
import StorefrontLayout from "components/storefront/StorefrontLayout";
import CustomerPortalLayout from "components/storefront/CustomerPortalLayout";

export const SHARED_PAGES = {
  home: HomePage,
  catalog: ProductCatalog,
  productDetail: ProductDetail,
  cart: Cart,
  checkout: Checkout,
  signIn: SignIn,
  layout: StorefrontLayout,
  portalLayout: CustomerPortalLayout,
};

export default {
  key: "shared",
  label: "Shared default",
  pages: SHARED_PAGES,
};
